import { render, staticRenderFns } from "./PanelEdit.vue?vue&type=template&id=6080f8f3&"
import script from "./PanelEdit.vue?vue&type=script&lang=js&"
export * from "./PanelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports